import { render, staticRenderFns } from "./configServerIP.vue?vue&type=template&id=5961bc3f&"
import script from "./configServerIP.vue?vue&type=script&lang=js&"
export * from "./configServerIP.vue?vue&type=script&lang=js&"
import style0 from "./configServerIP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports